import { styled, theme } from '@components-shared/src/stitches';

export const textStyles = {
  title: {
    fontFamily: '$title',
    fontWeight: '500',
  },

  subTitle: {
    fontFamily: '$base',
    fontWeight: '500',
    color: '$neutral800',
    opacity: 0.5,
  },

  heading: {
    fontFamily: '$title',
    color: '$neutral800',
    fontWeight: '500',
    fontSize: 22,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },

  subHeading: {
    fontFamily: '$base',
    color: '$neutral400',
    fontWeight: '500',
  },

  label: {
    fontFamily: '$base',
    color: '$neutral600',
    fontWeight: '500',
  },
};

export const Container = styled('div', {
  width: '100%',
  background: '#fff',
});

export const ProfileWrapper = styled('div', {
  width: '100%',
  maxWidth: theme.widths.landingMaxWidth,
  margin: '0 auto',
  position: 'relative',
  top: 0,

  '@laptop': {
    paddingX: '$12',
  },

  '@desktop': {
    top: '-$24',
  },
});

export const Wrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  background: '#fff',
});

export const CtaWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%',
  border: '1px solid $neutral200',
  borderRadius: 8,
  p: {
    base: 'M',
    color: '$neutral400',
  },

  variants: {
    card: {
      true: {
        width: 'unset',
        height: '100%',

        '@tabletLandscape': {
          height: '100%',
        },
      },

      false: {
        marginTop: -5,

        '@tablet': {
          height: 373,
          marginTop: -10,
        },
      },
    },
  },
});

export const SubContainer = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  background: '$white',
  gap: 40,

  '@desktop': {
    paddingX: 0,
  },

  variants: {
    variant: {
      header: {
        background: 'none',
        paddingBottom: 12,
        '@tabletLandscape': {
          paddingBottom: 24,
        },
      },
      content: {
        gap: 0,
      },
    },
  },
});
